import makeStyles from '@mui/styles/makeStyles';
import palette from '../../../../theme/palette';

const useStyles = makeStyles(() => ({
  buttonBook: {
    display: 'flex',
    width: '100%',
    background: palette.utriper.lightblue,
    fontWeight: 'bold',
    color: 'white',
    '&:hover': {
      backgroundColor: palette.utriper.darkblue,
    },
  },
}));

export default useStyles;
